/**
 * Discount Form Shadow Root Styles
 * Injects custom CSS into shadow roots for discount form elements
 */

(function() {
  'use strict';

  // CSS to inject into shadow roots
  const discountFormStyles = `
    /* Custom styles for discount form shadow root */
    :host {
      --forms-accent-color: #892f21 !important;
      --forms-button-background-color: #892f21 !important;
      --forms-button-text-color: #ffffff !important;
    }

    ._formContainer_1q1d2_30 {
      /* Add your custom styles here */
    }

    ._formInputField_nag3b_7 {
      /* Input field styles */
    }

    ._formSubmitButton_cit2d_96 {
      /* Submit button styles */
      background-color: #892f21 !important;
      color: #ffffff !important;
    }

    ._formDisclaimer_cit2d_38 {
      /* Disclaimer styles */
    }

    ._formDisclaimer_cit2d_38 a {
      color: #892f21 !important;
    }
#app-embed [data-sizing="form-wrapper"] {
max-width: 100% !important;
}
#app-embed [data-testid="btn-form-submit"] {
width: max-content !important;
border-radius: 3px !important;
color: rgb(255, 255, 255) !important;
padding: 12px 30px !important;
font-weight: 700 !important;
margin: 0 auto !important;
}
#app-embed [data-testid="btn-form-submit"]:hover {
background-color: #333 !important;
background: #333 !important;
border-color: #333 !important;
opacity: 1 !important;
}
#app-embed [class*="_formDisclaimer"] {
font-size: 18px !important;
line-height: 18px;
display: block;
margin-top: 20px;
color: #fff;
}
#app-embed [class*="_formDisclaimer"] a {
color: #fff !important;
text-decoration: none !important;
}
#app-embed [class*="_formBannerHeading"] {
    font-size: 40px !important;
    line-height: 65px;
}
#app-embed [class*="_textBody"] p:first-child {
    font-size: 24px !important;
    line-height: 33px;
}
#app-embed [class*="_textBody"] p:last-child {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
}
   .discount-hero:has(#app-embed [data-current-step="success"]) .group-block-content .text-block {
  display: none !important;
}
  `;

  /**
   * Injects CSS into a shadow root
   * @param {ShadowRoot} shadowRoot - The shadow root to inject styles into
   */
  function injectStylesIntoShadowRoot(shadowRoot) {
    if (!shadowRoot) return;

    // Check if styles already injected
    const existingStyle = shadowRoot.querySelector('style[data-discount-form-custom]');
    if (existingStyle) return;

    // Create style element
    const style = document.createElement('style');
    style.setAttribute('data-discount-form-custom', 'true');
    style.textContent = discountFormStyles;

    // Inject into shadow root
    shadowRoot.appendChild(style);
  }

  /**
   * Finds and styles all shadow roots containing discount form
   */
  function styleDiscountFormShadowRoots() {
    // Find all elements with shadow roots that might contain the form
    const appEmbedRoots = document.querySelectorAll('[data-form-root="true"], #app-embed, ._appEmbedRoot_1d2l7_9');
    
    appEmbedRoots.forEach(element => {
      // Check if element has shadow root
      if (element.shadowRoot) {
        injectStylesIntoShadowRoot(element.shadowRoot);
      }
    });

    // Also check for any custom elements that might have shadow roots
    const allElements = document.querySelectorAll('*');
    allElements.forEach(element => {
      if (element.shadowRoot) {
        // Check if shadow root contains discount form
        const formContainer = element.shadowRoot.querySelector('[data-testid="form"], ._formContainer_1q1d2_30');
        if (formContainer) {
          injectStylesIntoShadowRoot(element.shadowRoot);
        }
      }
    });
  }

  /**
   * Uses MutationObserver to watch for dynamically added shadow roots
   */
  function observeForShadowRoots() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node has a shadow root
            if (node.shadowRoot) {
              styleDiscountFormShadowRoots();
            }
            
            // Check if the added node contains elements with shadow roots
            const shadowRootElements = node.querySelectorAll ? node.querySelectorAll('*') : [];
            shadowRootElements.forEach(el => {
              if (el.shadowRoot) {
                styleDiscountFormShadowRoots();
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Initialize when DOM is ready
   */
  function init() {
    // Try immediately
    styleDiscountFormShadowRoots();

    // Try after a short delay (for async loaded content)
    setTimeout(styleDiscountFormShadowRoots, 100);
    setTimeout(styleDiscountFormShadowRoots, 500);
    setTimeout(styleDiscountFormShadowRoots, 1000);

    // Set up observer for dynamically added content
    observeForShadowRoots();

    // Also listen for custom events that might indicate form is loaded
    document.addEventListener('DOMContentLoaded', styleDiscountFormShadowRoots);
    window.addEventListener('load', styleDiscountFormShadowRoots);
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

